<template>
    <DashboardLayout :user="user">
        <div class="border border-gray-300 bg-white rounded-lg shadow-lg max-w-4xl mx-auto pb-10">
            <!-- Header: My Accounts (Aligned Left) -->
            <div class="bg-gray-200 text-lg font-semibold px-6 py-3 rounded-t-lg text-left">
                My Accounts
            </div>

            <div class="px-6 py-4 flex space-x-4">
                <button 
                    class="px-6 py-2 rounded-full shadow-md font-semibold"
                    :class="activeTab === 'bank' ? 'bg-primary text-white' : 'bg-gray-300 text-gray-700'"
                    @click="navigateTo('bank')">
                    Bank Accounts
                </button>
                <button 
                    class="px-6 py-2 rounded-full shadow-md font-semibold"
                    :class="activeTab === 'loans' ? 'bg-primary text-white' : 'bg-gray-300 text-gray-700'"
                    @click="navigateTo('loans')">
                    Loans
                </button>
                <button 
                    class="px-6 py-2 rounded-full shadow-md font-semibold"
                    :class="activeTab === 'term' ? 'bg-primary text-white' : 'bg-gray-300 text-gray-700'"
                    @click="navigateTo('term')">
                    Deposits
                </button>
            </div>

            <div v-if="activeTab === 'bank'">
                <BankAccounts :user="user" />
            </div>
            <div v-else-if="activeTab === 'loans'">
                <BankLoans :user="user" />
            </div>
            <div v-else-if="activeTab === 'term'">
                <TermDeposits :user="user" />
            </div>

            
        </div>
    </DashboardLayout>

</template>

<script>


import DashboardLayout from "@/components/DashboardLayout.vue";
import BankAccounts from "./BankAccounts.vue";
import BankLoans from "./BankLoans.vue";
import TermDeposits from "./TermDeposits.vue";

export default {
    name: 'MyAccounts',
    components: {
        DashboardLayout, BankAccounts, BankLoans, TermDeposits
    },
    data() {
        return {
            user: {},
            activeTab: 'bank'
        };
    },
    computed:{
        currentComponent(){
            return this.activeTab == 'bank' ? 'BankAccounts' : this.activeTab == 'loans' ? 'BankLoans' : 'TermDeposits';
        }
    },
    created() {
        const userData = localStorage.getItem('user');
        if (!userData) {
            alert("Session expired. Please log in again.");
            this.$router.push("/");
            return;
        }
        this.user = JSON.parse(userData);

        if (this.$route.path === "/loans") this.activeTab = "loans";
        else if (this.$route.path === "/term-deposits") this.activeTab = "term";
        else this.activeTab = "bank";
    },
    watch: {
        // Watch for URL changes and update the active tab
        "$route.path"() {
            this.updateTabFromRoute();
        }
    },
    methods: {
        navigateTo(tab) {
            this.activeTab = tab;
            const routes = {
                bank: "/bank-accounts",
                loans: "/loans",
                term: "/term-deposits"
            };
            this.$router.push(routes[tab]);
        },
        updateTabFromRoute() {
            if (this.$route.path === "/loans") {
                this.activeTab = "loans";
            } else if (this.$route.path === "/term-deposits") {
                this.activeTab = "term";
            } else {
                this.activeTab = "bank";
            }
        }
    }
}

</script>
